import { type ReactNode } from "react";
import { useCanWrite } from "@/lib/permissions";

import { RoleGate } from "./role-gate";

export interface WriteOnlyProps {
  children: ReactNode;
  /** Rendered for read-only users instead of children (default: nothing). */
  fallback?: ReactNode;
  /**
   * The control's label: a read-only user gets it as a RoleLock — «Нужна роль
   * «Байер»» + «Запросить доступ» — instead of nothing. Set it on every
   * primary action (create, add); leave it off for row details.
   */
  lock?: ReactNode;
}

/**
 * WriteOnly mounts its children only when the current user holds a tracker
 * write role (tracker-admin / tracker-team-lead / tracker-member) or the
 * platform-admin realm role. With `lock`, a tracker-viewer sees the action
 * locked with the role it needs and a way to ask for it.
 */
export function WriteOnly({ children, fallback = null, lock }: WriteOnlyProps) {
  const canWrite = useCanWrite();
  if (lock !== undefined) return <RoleGate need="write" label={lock}>{children}</RoleGate>;
  return <>{canWrite ? children : fallback}</>;
}
